import FullPageLoader from "components/Loader/FullPage";
import React, { useEffect, useState } from "react";

const OldParentWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    const oldElement = document.getElementById("old-react-app");
    const oldStyleLink = document.getElementById("oldstyle-css") as HTMLLinkElement | null;

    if (oldStyleLink) {
      oldStyleLink.disabled = false;
    }

    setTimeout(() => {
      if (rootElement) {
        rootElement.style.display = "none";
      }

      if (oldElement) {
        oldElement.style.display = "block";
      }

      document.documentElement.style.setProperty("font-size", "12px", "important");

      setShowSpinner(false);
    }, 350);
  }, []);

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      {showSpinner && <FullPageLoader />}
      {children}
    </div>
  );
};

export default OldParentWrapper;
